export default __webpack_public_path__ + "static/media/icon_arrow_pointer.d3269f50.svg";